;(function (window, APP) {
	'use strict';

	APP.AppCacheManager = {
		cache_version: APP.getJStorage('web_version') || undefined,

		checkAndUpdate: function(xhr){
			var v = xhr.responseJSON && xhr.responseJSON.web_version || undefined;

			if(!v) return this;

			if(this.issetWebVersion() && !this.isEqualVersion(v)){
				this.update();
			}

			this.set(v);

			return this;
		},
		isEqualVersion: function(v){
			return this.cache_version === v;
		},
		issetWebVersion: function() {
			var cache_version = this.get();

			return !_.isNull(cache_version) && !_.isUndefined(cache_version);
		},
		set: function(v){
			this.cache_version = v;
			APP.setJStorage('web_version', this.cache_version);

			return this;
		},
		get: function(){
			return APP.getJStorage('web_version');
		},
		update: function(){
			window.applicationCache && window.applicationCache.status &&  window.applicationCache.update();

			APP.module().PubSub.trigger('updateready');

			return this;
		}
	}

})(window, APP);